module.exports = __webpack_public_path__ + "img/8_15.e903ed34.png";